<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-11-23 19:20:41
 * @LastEditTime: 2022-02-17 11:36:24
 * @LastEditors: chenguobiao
-->
<template>
  <div class="agreement" v-show="showAgreement">
    <div class="agreement--box">
      <div class="agreement__header">国际象棋赛事用户协议</div>
      <div class="agreement__content">
        <div class="agreement__content__body" v-html="agreementContent"></div>
        <template v-if="countDownTimes === 0">
          <div class="agreement__content__button" @click="agree">
            <img src="@/render/assets/images/auth/agreement-button-bg.png">
            <div class="agreement__footer__button__text">我已阅读本协议</div>
          </div>
        </template>
        <template v-else>
          <div class="agreement__content__button">
            <img src="@/render/assets/images/auth/agreement-disabled-button-bg.png">
            <div class="agreement__footer__button__text">我已阅读本协议（{{ countDownTimes }}s）</div>
          </div>
        </template>
      </div>
      <div class="agreement__close" @click="close">
        <img src="@/render/assets/images/auth/agreement-close.png">
      </div>
    </div>
  </div>

</template>

<script>
import { authAPI } from '@/apis'
import { Timer } from '@/render/utils'
import { AGREEMENT_COUNTDOWN } from '@/config/const'
export default {
  data() {
    return {
      agreementContent: '',
      showAgreement: false,
      countDownTimes: 0,
      timer: null
    }
  },
  watch: {
    showAgreement(showAgreement) {
      if (showAgreement && !this.$parent.agreementFlag) {
        this.startTimer()
      } else {
        this.timer.stop()
      }
    }
  },
  mounted() {
    this.getProtocol()
  },
  methods: {
    async getProtocol() {
      const result = await authAPI.postGetProtocol({ uid: 1 })
      this.agreementContent = result.data.content
      this.countDownTimes = result?.data?.readTime ?? 15
    },
    startTimer() {
      // this.countDownTimes = 15
      let timer = new Timer(this.countDownTimes)
      timer.start(this.$bus, AGREEMENT_COUNTDOWN)
      this.timer = timer
      this.$bus.on(AGREEMENT_COUNTDOWN, countDownTimes => {
        this.countDownTimes = countDownTimes
      })
    },
    agree() {
      this.$parent.agreementFlag = true
      this.close()
    },
    close() {
      this.showAgreement = false
    }
  }
}
</script>

<style lang="scss" scoped>
.agreement {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(#000000, 0.5);

  &--box {
    position: absolute;
    bottom: val(115);
    left: val(360);
    right: val(360);
    height: val(800);
    background: url('../../../assets/images/auth/agreement-bg.png') #fff no-repeat;
    background-size: 100%;
    border-radius: val(8);
    display: flex;
    flex-direction: column;
  }

  &__header {
    width: 100%;
    height: val(127);
    padding-top: val(66);
    font-size: val(24);
    font-weight: bold;
    color: #4E2500;
    text-align: center;
    line-height: val(24);
    box-sizing: border-box;
  }

  &__content {
    width: 100%;
    height: val(673);
    overflow: auto;
    padding: 0 val(77) val(64) val(77);

    &__body {
      font-size: val(14);
      line-height: val(30);
      color: #5E3C00;
    }

    &__button {
      position: relative;
      width: val(350);
      margin: 16px auto 0;

      &__text {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: val(24);
        color: #FFEFDB;
        cursor: pointer;
      }
    }
  }

  &__footer {
    padding-top: val(87);

    &__button {
      position: relative;
      width: val(350);
      margin: 0 auto;

      &__text {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: val(24);
        color: #FFEFDB;
        cursor: pointer;
      }
    }
  }

  &__close {
    position: absolute;
    left: 50%;
    bottom: val(-48);
    transform: translate(-50%, 100%);
    width: val(42);
    height: val(42);
    cursor: pointer;
  }
}
</style>
